import axios from "axios";
import {
  DropDown,
  FilterList,
  Message,
  PackageCard,
  Panel,
  ProductCard,
  ProductCardLink,
  ProductCardLinkPrice,
  ResponsivePagination,
  Spinner,
} from "dab-component-lib";
import _ from "lodash";
import React from "react";
import { compose, graphql, withApollo } from "react-apollo";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { changePage } from "../../actions/index";
import { default as I18n, default as i18n } from "../../I18n/I18n";
import {
  availableLanguages,
  categoriesTaxonomyQuery,
  childTerms,
  createNodeCartLineItem,
  createNodeCartLineItemWithSizes,
  currencyById,
  currentUserCart,
  currentUserQuery,
  getQuantitiesByRegion,
  lastInsertedProducts,
  productCategoriesTaxonomyQuery,
  productsFiltered,
} from "../../queries";
import { getTotalByRegion } from "../../utils";
import { ADD_ELEMENT } from "../../utils/constants";
import {
  ErrorStyle,
  GridContainerStyle,
  HiddenMobileStyle,
  LoadingStyle,
} from "../../utils/style-utils";
import {
  CardContainer,
  DropdownContainerStyle,
  FilterWrapperStyle,
  ListColStyle,
  ListRowStyle,
  TitleSimilarProductsStyle,
} from "./style";
import { getFilterIdsString } from "./utils";

const ITEMS_PER_PAGE = 3;

const ORDER_BY_OPTIONS = [
  {
    label: I18n.t("content.orderName"),
    value: "NAME",
  },
  {
    label: I18n.t("content.orderDate"),
    value: "CREATED",
  },
  {
    label: I18n.t("content.orderByType"),
    value: "FIELD_PRODUCT_CATEGORY_TARGET_ID",
  },
];

class List extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      products: [],
      orderField: "NAME",
      productsFiltered: [],
      purchased: false,
      error: false,
      errorId: "",
      loading: false,
      loadingProducts: false,
      errorQuantity: false,
      count: 0,
      filterProductType: [],
      filterProductLanguage: [],
      errorIdQuantity: "",
      isFilteredLanguage: false,
      similarProducts: [],
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    const { match, client, childTerms } = this.props;

    const hasCategoryChanged =
      prevProps.match.params.category !== match.params.category;

    if (hasCategoryChanged) {
      this.props.dispatch(changePage(1, 0));
      return;
    }

    const productCategoryFilter = getFilterIdsString(
      this.state.filterProductType
    );
    const prevProductCategoryFilter = getFilterIdsString(
      prevState.filterProductType
    );
    const productLanguageFilter = getFilterIdsString(
      this.state.filterProductLanguage
    );
    const prevProductLanguageFilter = getFilterIdsString(
      prevState.filterProductLanguage
    );

    const hasChildTerms =
      childTerms.childtermsGraphql1View &&
      childTerms.childtermsGraphql1View.results.length > 0;

    const hasDataChanged =
      prevProps.childTerms !== childTerms ||
      prevProps.productsFiltered !== this.props.productsFiltered ||
      prevState.orderField !== this.state.orderField ||
      prevProductCategoryFilter !== productCategoryFilter ||
      prevProductLanguageFilter !== productLanguageFilter;

    if (
      hasDataChanged &&
      !childTerms.loading &&
      !childTerms.error &&
      !this.props.productsFiltered.loading &&
      !this.props.productsFiltered.error
    ) {
      const tid = match.params.category;
      const productFilterArray = hasChildTerms
        ? productCategoryFilter.split(",")
        : [tid];

      this.setState({ loadingProducts: true });

      let { data } = await client.query({
        query: productsFiltered,
        variables: {
          tid: tid,
          page: this.props.currentPage - 1,
          pageSize: ITEMS_PER_PAGE,
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
          orderField: this.state.orderField,
          productCategoryFilter: productFilterArray,
          productLanguageFilter: productLanguageFilter.split(","),
        },
      });
      this.setState({
        products: data.productListGraphql1View.results,
        productsFiltered: data.productListGraphql1View.results,
        count: data.productListGraphql1View.count,
        loadingProducts: false,
      });
    }
  }

  createNodeCartLineItem = async (targetIdProduct, quantity, size) => {
    const { createNodeCartLineItem, createNodeCartLineItemWithSizes } =
      this.props;
    let result = [];
    if (size) {
      result = await createNodeCartLineItemWithSizes({
        variables: {
          title: `user: ${localStorage.getItem(
            "currentUid"
          )} + product: ${targetIdProduct}`,
          targetIdProduct,
          quantity: quantity.toString(),
          size,
        },
      });
    } else {
      result = await createNodeCartLineItem({
        variables: {
          title: `user: ${localStorage.getItem(
            "currentUid"
          )} + product: ${targetIdProduct}`,
          targetIdProduct,
          quantity: quantity.toString(),
        },
      });
    }
    return result;
  };

  handleAddToCart = async ({ id, settings: { quantity, size } }) => {
    const {
      currentUserCart,
      currentUserQuery,
      currencyById,
      getQuantitiesByRegion,
    } = this.props;

    this.setState({
      loading: true,
      error: false,
      errorId: "",
      errorQuantity: false,
    });
    let product = _.find(
      this.state.products,
      // @ts-ignore
      (product) => product.entityId === id
    );

    if (!product) {
      product = _.find(
        this.state.products,
        // @ts-ignore
        (product) => product.fieldCode === id
      );
    }

    // @ts-ignore
    let availability = getTotalByRegion(
      // @ts-ignore
      product.entityId.toString(),
      currentUserQuery.currentUserContext.fieldRegion,
      getQuantitiesByRegion.filteredProductsGraphqlAmountxRegionView.results
    );

    // @ts-ignore
    let max = product.fieldMaxShopQuantity;
    if (quantity <= availability && quantity <= max) {
      let nidObject = await this.createNodeCartLineItem(
        // @ts-ignore
        product.entityId,
        quantity,
        size
      );
      let nid = nidObject.data.createNodeCartLineItem.entity.nid;
      let currencyName = currencyById.nodeById.fieldCurrencyName;
      let uid = localStorage.getItem("currentUid");
      let res = {};
      if (
        !currentUserCart.error &&
        !currentUserCart.loading &&
        currentUserCart.currentusercartGraphql1View.results.length < 1
      ) {
        res = await axios.get(
          `${ADD_ELEMENT}/create/${nid}/${currencyName}/${uid}`
        );
      } else {
        let cartId = currentUserCart.currentusercartGraphql1View.results[0].id;
        res = await axios.get(
          `${ADD_ELEMENT}/${cartId}/${nid}/${currencyName}/${uid}`
        );
      }
      if (res.data.status === 1) {
        await currentUserCart.refetch();
        await this.setState({ loading: false, purchased: true });
      } else {
        await this.setState({ loading: false, error: true, errorId: id });
      }
    } else {
      this.setState({
        loading: false,
        errorIdQuantity: id,
        errorQuantity: true,
      });
    }
  };

  handleGoToDetail = (id) => {
    const { history } = this.props;
    history.push(`/product-detail/${id}`);
  };

  openPdf = (pdfUrl) => {
    window.open(pdfUrl, "__blank");
  };

  fetchMoreProducts = (numPage) => {
    const { dispatch } = this.props;
    dispatch(changePage(numPage, (numPage - 1) * 3));
  };

  showAvailability = () => {
    const { currentUserQuery } = this.props;
    if (!currentUserQuery.loading && !currentUserQuery.error) {
      let role = _.find(
        currentUserQuery.currentUserContext.roles,
        (role) => role.targetId === "visitor_customer"
      );
      if (role) {
        return false;
      }
      return true;
    }
  };

  getKitAvailability = (products) => {
    const { currentUserQuery, getQuantitiesByRegion } = this.props;
    let availability = 0;
    products.forEach((product, i) => {
      if (!getQuantitiesByRegion.filteredProductsGraphqlAmountxRegionView) {
        return 0;
      }
      if (i === 0 || product.entity.fieldAvailability < availability) {
        let quantityByRegion = getTotalByRegion(
          product.targetId.toString(),
          currentUserQuery.currentUserContext.fieldRegion,
          getQuantitiesByRegion.filteredProductsGraphqlAmountxRegionView.results
        );
        availability =
          quantityByRegion > product.entity.fieldAvailability
            ? product.entity.fieldAvailability
            : quantityByRegion;
      }
    });
    return availability <= 0 ? 0 : availability;
  };

  errorHandler() {
    if (this.state.errorQuantity) {
      return (
        <div>
          <Message
            description={I18n.t("errors.quantityPurchaseErrorDescription")}
            title={I18n.t("errors.quantityPurchaseError")}
          />
        </div>
      );
    }
    return (
      <div>
        <Message
          description={I18n.t("errors.purchaseErrorDescription")}
          title={I18n.t("errors.purchaseError")}
        />
      </div>
    );
  }

  render() {
    const {
      productsFiltered,
      childTerms,
      lastInsertedProducts,
      currencyById,
      availableLanguages,
      currentUserQuery,
      match,
      location,
      currentPage,
      categoriesTaxonomyQuery,
      getQuantitiesByRegion,
    } = this.props;
    const { similarProducts, filterProductType } = this.state;

    let filters = [];
    let categories = [];
    let categoriesSlider = [];
    if (!childTerms.loading && !childTerms.error) {
      childTerms.childtermsGraphql1View.results.forEach((term) => {
        let checked = false;
        // @ts-ignore
        if (filterProductType !== []) {
          // @ts-ignore
          let found = filterProductType.find((f1) => f1.tid === term.tid);
          if (found) {
            // @ts-ignore
            checked = found.checked;
          }
        }
        filters.push({
          checked: checked,
          label: term.name,
          tid: term.tid,
        });
      });

      if (location.state && location.state.filter) {
        filters = filters.map((filter) =>
          filter.tid === location.state.filter.tid
            ? { ...filter, checked: true }
            : filter
        );
      }
    }

    let languages = [];

    if (!availableLanguages.loading && !availableLanguages.error) {
      availableLanguages.taxonomygenericviewGraphql1View.results.forEach(
        (language) => {
          languages.push({
            label: language.name,
            tid: language.tid,
            checked:
              this.state.filterProductLanguage.length > 0
                ? // @ts-ignore
                  !!this.state.filterProductLanguage.find(
                    // @ts-ignore
                    (filt) => filt.label === language.name
                  ).checked
                : false,
          });
        }
      );
    }

    if (!categoriesTaxonomyQuery.loading && !categoriesTaxonomyQuery.error) {
      categoriesTaxonomyQuery.taxonomygenericviewGraphql1View.results.forEach(
        (category) => {
          if (category.fieldPromotedToFrontPage === true) {
            categories.push(category);
          }
        }
      );
      categories = categories.sort((a, b) => {
        return a.weight > b.weight ? 1 : b.weight > a.weight ? -1 : 0;
      });
      let parents =
        categoriesTaxonomyQuery.taxonomygenericviewGraphql1View.results.filter(
          (cat) => cat.parent[0].targetId === 0
        );
      categoriesSlider = parents.map((parent) => ({ ...parent, children: [] }));
      let children =
        categoriesTaxonomyQuery.taxonomygenericviewGraphql1View.results.filter(
          (cat) => cat.parent[0].targetId !== 0
        );
      children.forEach((category) => {
        categoriesSlider = categoriesSlider.map((cat) =>
          cat.tid === category.parent[0].targetId
            ? { ...cat, children: cat.children.concat([category]) }
            : cat
        );
      });
    }

    if (this.state.loading || getQuantitiesByRegion.loading) {
      return (
        <LoadingStyle>
          <Spinner size={150} />
        </LoadingStyle>
      );
    }

    return (
      <GridContainerStyle>
        {(productsFiltered.loading ||
          lastInsertedProducts.loading ||
          childTerms.loading ||
          currentUserQuery.loading ||
          getQuantitiesByRegion.loading) && (
          <LoadingStyle>
            <Spinner size={150} />
          </LoadingStyle>
        )}
        {(productsFiltered.error ||
          lastInsertedProducts.error ||
          childTerms.error ||
          currentUserQuery.error ||
          getQuantitiesByRegion.error) && (
          <ErrorStyle>
            <h3>{I18n.t("errors.listError")}</h3>
          </ErrorStyle>
        )}
        {!productsFiltered.loading &&
          !productsFiltered.error &&
          !availableLanguages.loading &&
          !availableLanguages.error &&
          !currencyById.loading &&
          !currencyById.error &&
          !getQuantitiesByRegion.loading &&
          !getQuantitiesByRegion.error && (
            <ListRowStyle>
              <ListColStyle quarter>
                {!childTerms.error &&
                  !childTerms.loading &&
                  childTerms.childtermsGraphql1View.results.length > 0 && (
                    <FilterWrapperStyle>
                      <Panel title={I18n.t("content.filterType")}>
                        <FilterList
                          onChange={({ options }) => {
                            this.setState({
                              filterProductType: options,
                            });
                            this.props.dispatch(changePage(1, 0));
                          }}
                          options={filters}
                        />
                      </Panel>
                      {match.params.category === "29" && (
                        <Panel title={I18n.t("content.filterLanguage")}>
                          <FilterList
                            onChange={({ options }) => {
                              this.setState({
                                filterProductLanguage: options,
                              });
                              this.props.dispatch(changePage(1, 0));
                            }}
                            options={languages}
                          />
                        </Panel>
                      )}
                    </FilterWrapperStyle>
                  )}
                {!lastInsertedProducts.loading &&
                  !lastInsertedProducts.error &&
                  lastInsertedProducts.lastInsertedProductsGraphql1View.results
                    .length > 0 && (
                    <HiddenMobileStyle>
                      <Panel title={I18n.t("content.lastInsertedProducts")}>
                        <div>
                          {lastInsertedProducts.lastInsertedProductsGraphql1View.results
                            .slice(0, 2)
                            .map((product) => (
                              <div key={product.entityId}>
                                <ProductCardLink
                                  handleGoToDetail={() =>
                                    this.handleGoToDetail(product.entityId)
                                  }
                                  id={
                                    product.fieldCode
                                      ? product.fieldCode
                                      : product.entityId
                                  }
                                  lang={
                                    localStorage.getItem("language")
                                      ? localStorage.getItem("language")
                                      : "it"
                                  }
                                  name={product.name}
                                  photoUrl={
                                    product.fieldProductImages.length > 0
                                      ? product.fieldProductImages[0].url
                                      : ""
                                  }
                                />
                              </div>
                            ))}
                        </div>
                      </Panel>
                    </HiddenMobileStyle>
                  )}
              </ListColStyle>
              <ListColStyle>
                {this.state.loadingProducts ? (
                  <LoadingStyle>
                    <Spinner size={100} />
                  </LoadingStyle>
                ) : this.state.productsFiltered.length > 0 ? (
                  <div>
                    <DropdownContainerStyle>
                      <DropDown
                        disabled={false}
                        expanded={false}
                        id="order-dropdown"
                        onChange={({ value }) =>
                          this.setState({ orderField: value })
                        }
                        options={ORDER_BY_OPTIONS}
                        placeholder={I18n.t("content.orderBy")}
                        selectedIndex={
                          ORDER_BY_OPTIONS.findIndex(
                            (option) => option.value === this.state.orderField
                          ) || 0
                        }
                        size="M"
                        skin="primary"
                      />
                    </DropdownContainerStyle>
                    {this.state.productsFiltered.map((product, i) => {
                      const {
                        fieldSizes,
                        fieldPrices,
                        entityId,
                        fieldPackageProductsRef,
                        fieldAbstract,
                        fieldMaxShopQuantity,
                        fieldPdfProduct,
                        fieldLinkToPdf,
                        fieldProductImages,
                      } = product;
                      let sizes = [];
                      fieldSizes.forEach((size) => {
                        sizes.push({
                          label: size.entity.fieldSizeName,
                          value: size.entity.fieldSizeName,
                        });
                      });
                      let currencySign = null;
                      let price = {};
                      if (!currencyById.error && !currencyById.loading) {
                        let currencyName =
                          currencyById.nodeById.fieldCurrencyName;
                        currencySign = currencyById.nodeById.fieldCurrencySign;
                        price = _.find(
                          fieldPrices,
                          (price) =>
                            price.entity.fieldCurrency ===
                            (currencyName ? currencyName : "EUR")
                        );
                      }
                      let showAv = this.showAvailability();
                      return (
                        <CardContainer key={entityId + i}>
                          {fieldPackageProductsRef.length > 0 ? (
                            <PackageCard
                              abstract={fieldAbstract.value}
                              availability={this.getKitAvailability(
                                fieldPackageProductsRef
                              )}
                              currency={currencySign}
                              disableCart={
                                !price ||
                                currentUserQuery.currentUserContext.uid === 0 ||
                                !this.getKitAvailability(
                                  fieldPackageProductsRef
                                ) ||
                                !fieldMaxShopQuantity
                              }
                              handleAddToCart={this.handleAddToCart}
                              handleGoToDetail={() =>
                                this.handleGoToDetail(entityId)
                              }
                              handleOnClickPdf={
                                fieldPdfProduct || fieldLinkToPdf
                                  ? () =>
                                      this.openPdf(
                                        fieldPdfProduct
                                          ? fieldPdfProduct.entity.url
                                          : fieldLinkToPdf.url.path
                                      )
                                  : null
                              }
                              id={entityId}
                              lang={
                                localStorage.getItem("language")
                                  ? localStorage.getItem("language")
                                  : "it"
                              }
                              maxQuantity={fieldMaxShopQuantity}
                              // @ts-ignore
                              name={product.name}
                              noRegionSelected={
                                !currentUserQuery.currentUserContext.fieldRegion
                              }
                              price={
                                price
                                  ? parseFloat(
                                      price.entity.fieldPriceAmount
                                    ).toFixed(2)
                                  : "N/A"
                              }
                              photoUrl={
                                fieldProductImages.length > 0
                                  ? fieldProductImages[0].url
                                  : ""
                              }
                              quantity={1}
                              showAvailabilityAmount={showAv}
                              showPrice={
                                localStorage.getItem("showPrices") === "true"
                              }
                              sizes={sizes}
                              totProducts={fieldPackageProductsRef.length}
                            />
                          ) : (
                            <ProductCard
                              abstract={fieldAbstract.value}
                              availability={getTotalByRegion(
                                // @ts-ignore
                                product.entityId.toString(),
                                currentUserQuery.currentUserContext.fieldRegion,
                                getQuantitiesByRegion
                                  .filteredProductsGraphqlAmountxRegionView
                                  .results
                              )}
                              currency={currencySign}
                              handleAddToCart={this.handleAddToCart}
                              handleGoToDetail={() =>
                                // @ts-ignore
                                this.handleGoToDetail(product.entityId)
                              }
                              handleOnClickPdf={
                                fieldPdfProduct || fieldLinkToPdf
                                  ? () =>
                                      this.openPdf(
                                        fieldPdfProduct
                                          ? fieldPdfProduct.entity.url
                                          : fieldLinkToPdf.url.path
                                      )
                                  : null
                              }
                              // @ts-ignore
                              id={product.fieldCode}
                              lang={
                                localStorage.getItem("language")
                                  ? localStorage.getItem("language")
                                  : "it"
                              }
                              // @ts-ignore
                              maxQuantity={product.fieldMaxShopQuantity}
                              // @ts-ignore
                              name={product.name}
                              noRegionSelected={
                                !currentUserQuery.currentUserContext.fieldRegion
                              }
                              price={
                                price
                                  ? parseFloat(
                                      price.entity.fieldPriceAmount
                                    ).toFixed(2)
                                  : "N/A"
                              }
                              photoUrl={
                                // @ts-ignore
                                product.fieldProductImages.length > 0
                                  ? // @ts-ignore
                                    product.fieldProductImages[0].url
                                  : ""
                              }
                              quantity={1}
                              showAvailabilityAmount={showAv}
                              showPrice={
                                localStorage.getItem("showPrices") === "true" &&
                                !_.find(
                                  currentUserQuery.currentUserContext.roles,
                                  (role) => role.targetId === "visitor_customer"
                                )
                              }
                              sizes={sizes}
                            />
                          )}
                          {((this.state.error &&
                            // @ts-ignore
                            product.fieldCode === this.state.errorId) ||
                            (this.state.errorQuantity &&
                              // @ts-ignore
                              product.fieldCode ===
                                this.state.errorIdQuantity)) &&
                            this.errorHandler()}
                        </CardContainer>
                      );
                    })}
                    {this.state.count > ITEMS_PER_PAGE && (
                      <ResponsivePagination
                        currentPage={currentPage}
                        handleNavigateToPage={(props) =>
                          this.fetchMoreProducts(props)
                        }
                        itemsPerPage={ITEMS_PER_PAGE}
                        itemsTotalCount={this.state.count}
                      />
                    )}
                  </div>
                ) : (
                  <div>
                    <Message
                      description={I18n.t("errors.noProductsDescription")}
                      title={I18n.t("errors.noProducts")}
                    />
                  </div>
                )}
                {similarProducts.length > 0 &&
                  // @ts-ignore
                  this.state.filterProductType.filter((fil) => fil.checked)
                    .length > 0 && (
                    <div>
                      <TitleSimilarProductsStyle>
                        {i18n.t("content.relatedProducts")}
                      </TitleSimilarProductsStyle>
                      {similarProducts.map(
                        ({
                          fieldCode,
                          fieldPrices,
                          entityId,
                          fieldAbstract,
                          fieldProductImages,
                          name,
                        }) => {
                          let price = {};
                          let currencySign = null;
                          if (!currencyById.error && !currencyById.loading) {
                            let currencyName =
                              currencyById.nodeById.fieldCurrencyName;
                            currencySign =
                              currencyById.nodeById.fieldCurrencySign;
                            price = _.find(
                              fieldPrices,
                              (price) =>
                                price.entity &&
                                price.entity.fieldCurrency ===
                                  (currencyName ? currencyName : "EUR")
                            );
                          }
                          return (
                            <ProductCardLinkPrice
                              key={entityId}
                              // @ts-ignore
                              abstract={fieldAbstract.value}
                              currency={currencySign}
                              handleGoToDetail={() =>
                                this.handleGoToDetail(entityId)
                              }
                              id={fieldCode}
                              lang={
                                localStorage.getItem("language")
                                  ? localStorage.getItem("language")
                                  : "it"
                              }
                              name={name}
                              photoUrl={
                                // @ts-ignore
                                fieldProductImages.length > 0
                                  ? // @ts-ignore
                                    fieldProductImages[0].url
                                  : ""
                              }
                              price={
                                price
                                  ? parseFloat(
                                      price.entity.fieldPriceAmount
                                    ).toFixed(2)
                                  : "N/A"
                              }
                              showPrice={
                                localStorage.getItem("showPrices") === "true" &&
                                !_.find(
                                  currentUserQuery.currentUserContext.roles,
                                  (role) => role.targetId === "visitor_customer"
                                )
                              }
                            />
                          );
                        }
                      )}
                    </div>
                  )}
              </ListColStyle>
            </ListRowStyle>
          )}
      </GridContainerStyle>
    );
  }
}

const mapStateToProps = ({ changePage }) => {
  return {
    currentPage: changePage.page,
    offset: changePage.offset,
  };
};

export default connect(mapStateToProps)(
  compose(
    graphql(productCategoriesTaxonomyQuery, {
      name: "productCategoriesTaxonomyQuery",
      options: () => ({
        variables: {
          vid: "product_categories",
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(categoriesTaxonomyQuery, {
      name: "categoriesTaxonomyQuery",
      options: () => ({
        variables: {
          vid: "product_categories",
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(productsFiltered, {
      name: "productsFiltered",
      options: (props) => ({
        variables: {
          // @ts-ignore
          tid: props.match.params.category,
          page: 0,
          pageSize: 3,
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
        fetchPolicy: "network-only",
      }),
    }),
    graphql(getQuantitiesByRegion, {
      name: "getQuantitiesByRegion",
      options: (props) => ({
        variables: {
          field_product_category_target_id:
            // @ts-ignore
            props.match.params.category === "29"
              ? ["29", "33", "34", "35", "36"]
              : // @ts-ignore
                [props.match.params.category],
          id: null,
          name: localStorage.getItem("userRegion")
            ? localStorage.getItem("userRegion")
            : "ITALY",
        },
      }),
    }),
    graphql(lastInsertedProducts, {
      name: "lastInsertedProducts",
      options: (props) => ({
        variables: {
          // @ts-ignore
          tid: props.match.params.category,
          langcode: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(childTerms, {
      name: "childTerms",
      options: (props) => ({
        variables: {
          // @ts-ignore
          tid: props.match.params.category,
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
        fetchPolicy: "network-only",
      }),
    }),
    graphql(availableLanguages, {
      name: "availableLanguages",
      options: () => ({
        variables: {
          vid: "product_languages",
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(currentUserCart, {
      name: "currentUserCart",
      options: () => ({
        variables: {
          id: localStorage.getItem("currentUid"),
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(createNodeCartLineItem, {
      name: "createNodeCartLineItem",
    }),
    graphql(createNodeCartLineItemWithSizes, {
      name: "createNodeCartLineItemWithSizes",
    }),
    graphql(currentUserQuery, {
      name: "currentUserQuery",
    }),
    graphql(currencyById, {
      name: "currencyById",
      options: () => ({
        variables: {
          id: localStorage.getItem("currency")
            ? localStorage.getItem("currency")
            : localStorage.getItem("defaultCurrency"),
        },
      }),
    })
  )(withRouter(withApollo(List)))
);



// WEBPACK FOOTER //
// ./src/components/list/index.js